import { GlobalAxios } from "../axios/axios-config";
import { IIServiceType } from "../models/i-service-type";

const I_SERVICE_TYPE_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/IServiceType/";

export const iServiceTypeList = (params?: any) => {
  return GlobalAxios.get<IIServiceType[]>(I_SERVICE_TYPE_ROUTE + "list", {
    params: params,
  });
};

export const iServiceTypeListByAutomation = (params?: {
  automationId?: string | null;
  SearchBy?: string;
}) => {
  return GlobalAxios.get<IIServiceType[]>(
    I_SERVICE_TYPE_ROUTE + `list-by-automation/${params?.automationId}`,
    {
      params: {
        searchBy: params?.SearchBy,
      },
    },
  );
};
